import { render } from "./groupInfo.vue?vue&type=template&id=a300cc5c"
import script from "./groupInfo.vue?vue&type=script&lang=js"
export * from "./groupInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__